import { VType } from 'src/constants/constants';
import { XYLEM } from 'src/constants/type';
import { logger } from 'src/services/logger/loggerService';
import defaultUserIconOTT from 'src/shared/core/assets/images/defaultUserIconOTT.svg';
import profileLight from 'src/shared/core/assets/images/profileLight.svg';
import PwDefaultLogo from 'src/shared/core/assets/images/PwDefaultLogo.svg';
import XylemDefaultLogo from 'src/shared/core/assets/images/xylem-default-logo.svg';

import { ScheduleDetails } from './hooks/video-player/useScheduleDetails';

const searchParams = new URLSearchParams(window.location.search);
const vType = searchParams.get('vType');

export const isOTT = (): boolean => {
  return vType === VType.OTT || vType === VType.OTT_DPP;
};

export const NumberShortText = (num: number, digits = 2) => {
  const lookup = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'G' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' },
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  const item = lookup
    .slice()
    .reverse()
    .find(function (item) {
      return num >= item.value;
    });
  return item ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol : '0';
};
export const parseMutationObject = (data: any) => {
  if (typeof data === 'string') {
    return data;
  }
  if (data) {
    return JSON.parse(JSON.stringify(data));
  }
  return null;
};
export const getImageUrlFromObjectImageId = (
  imageObject: any,
  cameFrom?: string,
  defaultImage?: any,
  OTT?: boolean,
) => {
  if ((imageObject?.baseUrl || imageObject?.base_url) && imageObject?.key) {
    return (imageObject?.baseUrl || imageObject?.base_url) + imageObject?.key;
  }
  if (OTT) {
    return defaultUserIconOTT;
  }

  return profileLight || (cameFrom === XYLEM ? XylemDefaultLogo : PwDefaultLogo);
};
export const getAssetUrlFromObjectAssetId = (imageObject: any, defaultImage?: any) => {
  if (imageObject?.baseUrl && imageObject?.key) {
    return imageObject?.baseUrl + imageObject?.key;
  }
  return defaultImage || 'https://www.pw.live//version14/assets/img/logo.png';
};
export const getPlayerState = (): 'buffering' | 'paused' | 'playing' | null => {
  // @ts-ignore
  const player = window.player;
  if (player) {
    // @ts-ignore
    return window.buffering ? 'buffering' : player.paused() ? 'paused' : 'playing';
  }
  return null;
};
export const generateWhatsappLink = (batchSlug: string) => {
  const urlEncodedText = encodeURI(
    `Looking for quality education content at an affordable prices? Check out this course from PhysicsWallah and get enrolled to crack the toughest exams with best in class study material and top rated faculties. : https://www.pw.live/k8/batches/${batchSlug}`,
  );
  return `https://api.whatsapp.com/send?text=${urlEncodedText}`;
};

export const truncateString = (str: string, limit: number): string => {
  return str.length > limit ? str.slice(0, limit) + '...' : str;
};

export const isScheduleLive = (scheduleData: ScheduleDetails | any): boolean => {
  if (!scheduleData || !scheduleData.startTime || !scheduleData.endTime) {
    return false;
  }
  return (
    new Date().getTime() < new Date(scheduleData?.endTime).getTime() &&
    new Date().getTime() > new Date(scheduleData?.startTime).getTime()
  );
};

export const downloadFile = (url: string, fileName: string) => {
  try {
    fetch(url).then((response) => {
      response.blob().then((blob) => {
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        const alink = document.createElement('a');
        alink.href = fileURL;
        alink.download = `${fileName}.pdf`;
        alink.click();
      });
    });
  } catch (e) {
    logger.error('download pdf error', e);
  }
};

export const querySplitter = (query: string) => {
  query = query[0] === '?' ? query.substring(1, query.length - 1) : query;
  const cookieArr = query.split('&');
  const queryObj: any = {};
  for (let i = 0; i < cookieArr.length; i++) {
    const cookiePart = cookieArr[i].split(/=(.*)/s); // splits from first occurrence of "="
    queryObj[cookiePart[0]] = cookiePart[1];
  }
  return queryObj;
};

export const modifyMeta = (meta: any) => {
  const newMeta = meta.map((m: any) => {
    const str = m.key.split('_').join(' ').toLowerCase();
    return {
      ...m,
      key: str,
    };
  });
  return newMeta;
};

export const removeByAttr = (arr: any, attr: string, value: any) => {
  let i = arr?.length;
  while (i--) {
    if (arr[i] && arr[i].hasOwnProperty(attr) && arr[i][attr] === value) {
      arr.splice(i, 1);
    }
  }
  return arr;
};

export const convertTimestampToTime = (timestamp: number) => {
  const hours = Math.floor(timestamp / 3600);
  const minutes = Math.floor((timestamp % 3600) / 60);
  const seconds = timestamp % 60;

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  } else {
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }
};

export async function handlePutRequest(apiUrl: string, data: any) {
  try {
    const response = await fetch(apiUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'audio/mp3',
      },
      body: data,
    });

    if (response.ok) {
      console.log('PUT request successful');
      return true;
    } else {
      throw new Error('PUT request failed');
    }
  } catch (error) {
    return false;
  }
}

export function formatTime(totalSeconds: number) {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = Math.floor(totalSeconds % 60);
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}

export const NOTES_MODE = {
  NOTES: 'NOTES',
  ADD_NOTE: 'ADD NOTE',
  EDIT_NOTE: 'EDIT NOTE',
};

export function blobToBase64(blob: any): Promise<string> {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.readAsDataURL(blob);
  });
}

export function getBlobDuration(blob: any) {
  return new Promise((resolve, reject) => {
    const audioContext = new AudioContext();
    const fileReader = new FileReader();

    fileReader.onload = async () => {
      try {
        const arrayBuffer = fileReader.result;
        if (arrayBuffer instanceof ArrayBuffer) {
          const audioBuffer = await audioContext.decodeAudioData(arrayBuffer); // some error with edit change
          resolve(audioBuffer.duration);
        } else {
          reject(new Error('Invalid array buffer'));
        }
      } catch (error) {
        reject(error);
      } finally {
        audioContext.close();
      }
    };

    fileReader.readAsArrayBuffer(blob);
  });
}

declare global {
  interface Window {
    opera?: {
      [property: string]: any;
    };
    player: any;
    watchStats: any;
  }
}

export function isMobile() {
  let check = false;
  (function (a: any) {
    // eslint-disable-next-line max-len
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a,
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4),
      )
    ) {
      check = true;
    }
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}
export function mobileAndTabletCheck() {
  let check = false;
  // eslint-disable-next-line max-len
  (function (a: any) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a,
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4),
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window?.opera);
  return check;
}
